/**
 * Compact, i18n-aware duration formatting.
 *
 * Shows the two largest non-zero units with localized short labels — e.g.
 * "2 ว 3 ชม." / "3 ชม. 37 น." / "5 น. 12 วิ". Unit labels come from
 * react-i18next keys (time.d/h/m/s) so all 7 languages are covered, including
 * Lao/Burmese which date-fns has no locale for. Pass `t` from useTranslation.
 *
 * The arithmetic is NOT here. `durationParts` in `@b1fr0st/shared/time` owns
 * "which two units does this span read in", because the back office renders the
 * same shape on its shift board and used to do so from a verbatim copy of this
 * file. Only the labelling is app-local, and it has to be: the keys come from
 * each app's own i18n catalogue. The subpath is taken rather than the package
 * barrel, which pulls pino and postgres into the bundle.
 */
import { durationParts } from '@b1fr0st/shared/time';

type TFunc = (key: string) => string;

export function formatDurationShort(totalSeconds: number, t: TFunc): string {
  return durationParts(totalSeconds)
    .map((part) => `${part.value} ${t(`time.${part.unit}`)}`)
    .join(' ');
}
